import React from 'react'
import whyDidYouRender from '@welldone-software/why-did-you-render'

const {DEV, VITE_WDYR} = import.meta.env

if (DEV && VITE_WDYR) {
    whyDidYouRender(React, {
        //trackAllPureComponents: true,
    })
}
